import { render, staticRenderFns } from "./FacilityDisplayEmergencyTab.vue?vue&type=template&id=53bb0b6a"
import script from "./FacilityDisplayEmergencyTab.vue?vue&type=script&lang=js"
export * from "./FacilityDisplayEmergencyTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports